import { StatusBadge } from '@/components/common/StatusBadge';
import {
  LEAVE_REQUEST_TYPE_LABELS,
  LEAVE_REQUEST_TYPE_TONE,
} from '../constants/leaveApplication.constants';
import type { LeaveRequestType } from '../types/leaveApplication.types';

interface LeaveRequestTypeBadgeProps {
  requestType: LeaveRequestType;
}

export function LeaveRequestTypeBadge({ requestType }: LeaveRequestTypeBadgeProps) {
  return (
    <StatusBadge tone={LEAVE_REQUEST_TYPE_TONE[requestType]}>
      {LEAVE_REQUEST_TYPE_LABELS[requestType]}
    </StatusBadge>
  );
}
